"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _react = require("react");

/**
 * @module hooks
 * @name useInterval
 * @link https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
var _default = useInterval;
/**
 * @name useInterval
 * @desc Interval hook.
 * @param {function} callback
 * @param {number|null} delay
 * @param {boolean} delayedInit
 */

exports.default = _default;

function useInterval(callback, delay) {
  var delayedInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var savedCallback = (0, _react.useRef)(); // Remember the latest callback.

  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  (0, _react.useEffect)(function () {
    var tick = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return savedCallback.current();

              case 2:
                if (id !== null) {
                  id = setTimeout(tick, delay);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function tick() {
        return _ref.apply(this, arguments);
      };
    }();

    var id = setTimeout(tick, delayedInit ? delay : 0);
    return function () {
      clearTimeout(id);
      id = null;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay]);
}